import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// fiscal_years — ปีภาษี/ปีการเงิน
// ============================================================================
export const fiscalYears = sqliteTable("accounting_fiscal_years", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  yearName: text("year_name").notNull(), // e.g., "2026", "2025-2026"
  startDate: text("start_date").notNull(), // YYYY-MM-DD
  endDate: text("end_date").notNull(), // YYYY-MM-DD
  isClosed: integer("is_closed").notNull().default(0), // 0=open, 1=closed
  closedAt: text("closed_at"),
  closedBy: text("closed_by"),
  reopenedAt: text("reopened_at"),
  reopenedBy: text("reopened_by"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  // ม.87/3 compliance — historical GL references fiscal year bounds; never hard-delete.
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type FiscalYear = typeof fiscalYears.$inferSelect;
export type NewFiscalYear = typeof fiscalYears.$inferInsert;
